import { create } from "zustand";
import { deleteMarketAera, getBannerData, getCapabilityData, getHomeData, postAboutUs, postCapability, postMarketarea, postNewMarketArea, postProjectAnalystics, postServicearea } from "../api/home";


export const useHomeStore = create((set, get) => ({
    loading: true,
    about: null,
    banner: null,
    capabilityPage: null,
    capability: [],
    serviceArea: null,
    project: null,
    marketArea: null,
    analytics: null,
    selectedMarketAera: null,

    getHome: async () => {
        try {
            set({ loading: true })
            const res = await getHomeData()
            set({
                loading: false,
                about: res?.about,
                marketArea: res?.marketArea,
                serviceArea: res?.serviceArea,
                analytics: res?.analytics,
            })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getBanner: async () => {
        try {
            set({ loading: true })
            const res = await getBannerData('home')
            set({ loading: false, banner: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getCapability: async () => {
        try {
            set({ loading: true })
            const res = await getCapabilityData()
            const data = {
                title: res?.title,
                subTitle: res?.subTitle
            }
            set({ loading: false, capability: res?.capability, capabilityPage: data })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    registerAbout: async () => {
        try {
            set({ loading: true })

        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ loading: false });
            return false;
        }
    },
    postAboutUs: async (formData) => {
        try {
            set({ loading: true });
            const res = await postAboutUs(formData);
            set({
                loading: false,
            });
            console.log("about", res)
            return res;

        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        }
    },
    postServiceArea: async (formData) => {
        try {
            set({ loading: true });
            const res = await postServicearea(formData);
            set({
                loading: false,
            });
            console.log("postServiceArea", res)
            return res;

        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        }
    },
    postMarketArea: async (formData) => {
        try {
            set({ loading: true });
            const res = await postMarketarea(formData);
            set({
                loading: false,
            });
            return res;

        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        }
    },
    addNewMarketArea: async (formData) => {
        try {
            set({ loading: true });
            const res = await postNewMarketArea(formData);
            set({
                loading: false,
            });
            return res;

        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        }
    },
    deleteMarketArea: async (id) => {
        try {
            set({ loading: true });
            const res = await deleteMarketAera(id);
            if (res) {
                const currentmarketarea = get().marketArea?.area || []
                const updatedmarketarea = currentmarketarea.filter((ele) => ele._id !== id);
                let marketArea = get().marketArea
                marketArea.area = updatedmarketarea
                set({ marketArea: marketArea });
            }
            set({ loading: false })
            return res;

        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        }
    },
    getMarketAreaById: async (id) => {
        if (!get().marketArea) {
            await get().getHome()
        }

        let areaMarket = get().marketArea?.area || []
        for (let i of areaMarket) {
            if (String(i?._id) === id) {
                set({ selectedMarketAera: i })
                return i
            }
        }
        return null
    },
    postProjectanalytics: async (formData) => {
        try {
            set({ loading: true });
            const res = await postProjectAnalystics(formData);
            set({
                loading: false,
            });
            console.log("postProjectanalytics", res)
            return res;

        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        }
    },
    postCapability: async (form) => {
        try {
            set({ loading: true })
            const capabilityPage = get().capabilityPage;
            const res = await postCapability(form, capabilityPage)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        }
    }

}));
